export default __webpack_public_path__ + "static/media/flexline_black_logo_en.bfb9c894.png";